export class SapAgentHeartbeatInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "agentVersion",
            "baseName": "agentVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "cdcLagSeconds",
            "baseName": "cdcLagSeconds",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SapAgentHeartbeatInput.attributeTypeMap;
    }
    constructor() {
    }
}
